import React from 'react'

import { Icon } from '@fourthwall/components'

import { getIcon } from '../../utils/getIcon'
import * as S from './styled'
import type { Props } from './types'

export const SectionItem = ({ section, active, onClick }: Props) => {
  const { sectionType, name } = section

  return (
    <S.Item $active={active} onClick={onClick}>
      <S.Container>
        <S.Wrapper>
          <Icon component={getIcon(sectionType)} height={15} />
        </S.Wrapper>
        <S.Text>
          <span>{name}</span>
        </S.Text>
      </S.Container>
    </S.Item>
  )
}
